module.exports = __webpack_public_path__ + "img/create-prof.781fda39.svg";